"use client";
import { jsx as e } from "react/jsx-runtime";
import { useRef as t } from "react";
//#region src/components/controls/useHoverHighlight.tsx
var n = () => {
	let n = t(null), r = t(null), i = t(null), a = () => {
		r.current?.removeAttribute("data-pointer-highlight"), n.current && (n.current.hidden = !0), i.current = null;
	};
	return {
		props: {
			onPointerMove: (e) => {
				if (e.pointerType !== "mouse" || typeof matchMedia != "function" || !matchMedia("(hover: hover) and (pointer: fine)").matches) return;
				let t = e.currentTarget, o = e.target.closest("[role=\"menuitem\"], [role=\"option\"]"), s = n.current;
				if (!o || !t.contains(o) || o.getAttribute("aria-disabled") === "true") {
					(o || !e.target.closest("[role=\"listbox\"], [role=\"menu\"]")) && a();
					return;
				}
				if (!s || o === i.current) return;
				let c = t.getBoundingClientRect(), l = o.getBoundingClientRect(), u = c.width / t.offsetWidth || 1;
				r.current = t, i.current = o, s.hidden = !1, t.setAttribute("data-pointer-highlight", ""), s.toggleAttribute("data-destructive", o.hasAttribute("data-destructive")), Object.assign(s.style, {
					left: `${String((l.left - c.left) / u + t.scrollLeft - t.clientLeft)}px`,
					top: `${String((l.top - c.top) / u + t.scrollTop - t.clientTop)}px`,
					width: `${String(l.width / u)}px`,
					height: `${String(l.height / u)}px`
				});
			},
			onPointerLeave: a,
			onKeyDownCapture: a,
			onScrollCapture: a
		},
		highlight: /* @__PURE__ */ e("div", {
			ref: n,
			hidden: !0,
			"aria-hidden": "true",
			className: "pf:absolute pf:pointer-events-none pf:origin-top-left pf:rounded-sm pf:bg-soft-pearl-200 pf:data-destructive:bg-red-100"
		})
	};
}, r = "pf:relative pf:[&[data-pointer-highlight]_[data-highlighted]]:bg-transparent!";
//#endregion
export { r as hoverHighlightClass, n as useHoverHighlight };
